import { getCoreDataSecurityAlertsSlice } from './get';
import { postCoreDataSecurityAlertSlice } from './post';

export const { requestGetCoreDataSecurityAlerts, resetGetCoreDataSecurityAlerts } =
	getCoreDataSecurityAlertsSlice.asyncActionCreators;

export const { requestPostCoreDataSecurityAlert, resetPostCoreDataSecurityAlert } =
	postCoreDataSecurityAlertSlice.asyncActionCreators;

export * from './export/actions';
